import { Dispatch } from "redux";
import apiFetch from "../token-guard/apiFetch";

export async function getUserProfile(
  dispatch: Dispatch<any>,
  onUnauthorized?: () => void
) {
  try {
    const response = await apiFetch("/api/users/getProfile", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },dispatch);
    if (response.status === 401 && onUnauthorized) {
      onUnauthorized();
      return { code: 401 };
    }
    return await response;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
}
